import React from "react";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";

import { fetchReceipt } from "../../../redux/slices/receiptSlice";
import {
    selectHasParentRegistration,
    setAppHasSubmittedRegistration,
} from "../../../redux/slices/appSettingsSlice";
import {
    setErroredEntities,
    setOutdated,
} from "../../../redux/slices/raceConditionsSlice";
import { updateRegistrationAccount } from "../../../redux/slices/registrationAccountSlice";
import { selectSessionReduxData } from "../../../redux/slices/formDataSlice";
import {
    selectRegistrationTotals,
    selectAllRegistration,
} from "../../../redux/slices/registrationSlice";
import {
    selectAllP2pSettings,
    selectBaseUrl,
} from "../../../redux/slices/p2pSettingsSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectParentRegistration } from "../../../redux/slices/parentRegistrationSlice";
import { selectCurrentForm } from "../../../redux/slices/currentFormSlice";
import { selectAllCategories } from "../../../redux/slices/categoriesSlice";
import { selectAllClassifications } from "../../../redux/slices/classificationsSlice";
import { selectAllProducts } from "../../../redux/slices/productsSlice";
import { selectAllProductSettings } from "../../../redux/slices/productSettingsSlice";
import { selectCmsSettings } from "../../../redux/slices/cmsSettingsSlice";
import { selectAllFields } from "../../../redux/slices/fieldsSlice";
import { updateCurrentPage } from "../../../redux/slices/currentPageSlice";
import EarlyRegistrationSubmit from "./EarlyRegistrationSubmit";

const ConnectedEarlyRegistrationSubmit = () => {
    const sessionStorageReduxData = useSelector(selectSessionReduxData);
    const formSettings = useSelector(selectAllFormSettings);
    const p2pSettings = useSelector(selectAllP2pSettings);
    const totals = useSelector(selectRegistrationTotals);
    const registration = useSelector(selectAllRegistration);
    const hasParentRegistration = useSelector(selectHasParentRegistration);
    const formId = useSelector(selectCurrentForm);
    const baseUrl = useSelector(selectBaseUrl);
    const parentRegistration = useSelector(selectParentRegistration);
    const categories = useSelector(selectAllCategories);
    const classifications = useSelector(selectAllClassifications);
    const products = useSelector(selectAllProducts);
    const productSettings = useSelector(selectAllProductSettings);
    const cmsSettings = useSelector(selectCmsSettings);
    const fields = useSelector(selectAllFields);
    const {
        classification = {},
        registrations = [{}],
        promoDiscounts = {},
        storeCart = [],
    } = registration;
    const { shippingMethodAmount = 0 } = totals;
    const { values, setSubmitting, setErrors } = useFormikContext();

    const { transaction = {}, participants = [] } = promoDiscounts;

    const settings = {
        categories,
        classifications,
        formSettings,
        p2pSettings,
        products,
        productSettings,
        cmsSettings,
        fields,
    };

    const parentRegistrationId = hasParentRegistration
        ? parentRegistration.registrationId
        : "0";

    const earlyRegistrationSubmitProps = {
        baseUrl,
        settings,
        classification,
        sessionStorageReduxData,
        registrations,
        formId,
        discounts: { transaction, participants },
        storeCart,
        parentRegistrationId,
        shippingMethodAmount,
        values,
        setSubmitting,
        setErrors,
        totals,
        fetchReceipt,
        setAppHasSubmittedRegistration,
        setErroredEntities,
        setOutdated,
        updateCurrentPage,
        updateRegistrationAccount,
    };

    return <EarlyRegistrationSubmit {...earlyRegistrationSubmitProps} />;
};

export default ConnectedEarlyRegistrationSubmit;
